import React from "react";
import { useDispatch } from "react-redux";
import { EventFullData } from "../../types";
import { currencies, statusNames } from "../../constants/events";
import ManInfoText from "../ui/manInfoText";
import { closeModal, openModal } from "../../state/modalSlice";
import UpdateEventModal from "../../modals/event/updteEventStatus";
import { actions } from "../../state/reducer";
import {
  formatDateOfEvent,
  generateRandomString,
  isEventOutdated,
} from "../../utils";
import UpdateEventDateModal from "../../modals/event/updateEventDate";
import { commentBackend, eventBackend } from "../../services";
import { toast } from "sonner";
import EventAddUserModal from "../../modals/event/updateEventUser";
import ShortManInfo from "../../components/ui/shortItem";

const EventDetailInfoCard = (props: { data: EventFullData }) => {
  const { data } = props;
  const dispatch = useDispatch();

  const statusName = statusNames.find((item) => {
    return item.id === data.status_id;
  })?.name;

  const deleteUserFrom = (user_id: number) => {
    console.log("Delete:", user_id);
  };

  console.log("Users:", data.users);

  const responsible =
    data.users.find((user) => {
      return user.role_id === 2;
    }) ||
    data.users.find((user) => {
      return user.role_id === 1;
    });

  const currencySymbol = data.deal
    ? currencies.find((c) => c.id === data.deal?.currency_id)?.symbol || ""
    : "";

  const isOutdated =
    isEventOutdated(data.date_end) && Number(data.status_id) === 1;

  const statusComponent = (() => {
    switch (true) {
      case isOutdated:
        return <div className="status emergency">Просрочено</div>;
      case data.status_id === 1:
        return <div className="status light">Запланировано</div>;
      case data.status_id === 2:
        return <div className="status gray">Обработано</div>;
      case data.status_id === 3:
        return <div className="status green">Выполнено</div>;
    }
  })();

  const statusText = (() => {
    switch (data.status_id) {
      case 1:
        return "Запланировано";
      case 2:
        return "Обработано";
      case 3:
        return "Выполнено";
    }
  })();

  const handleOpenStatusModal = () => {
    dispatch(
      openModal({
        component: UpdateEventModal,
        context: {
          event_id: data.event_id,
          onSave: () => {
            dispatch(actions.selectItem(generateRandomString(4)));
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  // UpdateEventDateModal
  const handleOpenDateModal = () => {
    dispatch(
      openModal({
        component: UpdateEventDateModal,
        context: {
          event_id: data.event_id,
          onSave: () => {
            dispatch(actions.selectItem(generateRandomString(4)));
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  const handleAddUserModal = () => {
    dispatch(
      openModal({
        component: EventAddUserModal,
        context: {
          event_id: data.event_id,
          onSave: (
            userId: number,
            statusid: number,
            comment: string,
            itemid = data.event_id
          ) => {
            if (comment && comment.length > 0) commentBackend.addComment({
              tab_id: 1,
              item_id: data.event_id,
              comment,
            });
            Promise.all([
              eventBackend.addUserToEvent({
                eventid: itemid,
                participantid: userId,
                statusid,
              }),
            ])
              .then((res) => {
                if (res) {
                  dispatch(actions.selectItem(generateRandomString(4)));
                  toast("Пользователь успешно добавлен");
                }
              })
              .catch((err) => {
                toast("ошибка добавления пользователя");
              })
              .finally(() => {
                dispatch(closeModal());
              });
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  return (
    <>
      <div className="detailPanel">
        <div className="panelCoontainer">
          <div className="panelHeader commentsHeader">
            <h2>{data.type_name}</h2>
            {statusComponent}
          </div>
          <div className="flex between">
            <div className="field">
              <label>Статус события</label>
              <div className="flex gap6">
                <div className="value">{statusText}</div>
                <div className="value">
                  <span
                    className="value underline"
                    onClick={handleOpenStatusModal}
                  >
                    Изменить статус
                  </span>
                </div>
              </div>
            </div>
            <div className="field">
              <label>Тип события</label>
              <div className="value">{data.type_name}</div>
            </div>
          </div>
          <div className="field">
            <label>Дата завершения</label>
            <div className="flex gap6">
              <div className="value">
                {data.date_end
                  ? formatDateOfEvent(new Date(data.date_end))
                  : "Не задана"}
              </div>
              <div className="value">
                <span className="value underline" onClick={handleOpenDateModal}>
                  Изменить дату
                </span>
              </div>
            </div>
          </div>
          {data.deal && (
            <div className="field">
              <label>Сумма и валюта</label>
              <div className="value large">{`${data.deal?.amount},00 ${currencySymbol}`}</div>
            </div>
          )}
          {data.customer && (
            <div className="field">
              <label>Клиент</label>
              <a href={`/client/${data.customer.id}`}>
                <ShortManInfo
                  name={`${data.customer?.last_name} ${data.customer?.first_name}`}
                  phone={`${data.customer?.phone}`}
                />
              </a>
            </div>
          )}
          <div className="flex gap6">
            <div className="field">
              <label>
                Ответственный <span style={{ color: "#B4173A" }}>*</span>
              </label>
              <div className="flex gap12">
                <ShortManInfo
                  name={
                    responsible?.info
                      ? `${responsible?.info?.last_name} ${responsible?.info?.first_name}`
                      : "Неизвестно"
                  }
                  phone={`${responsible?.info?.phone}`}
                  photo={`${responsible?.info?.photo}`}
                />
                <div className="value" onClick={handleAddUserModal}>
                  <span className="value underline">
                    Назначить
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventDetailInfoCard;
